import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";
import pxToRem from "libs/pxToRem";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CircularProgress from "@mui/material/CircularProgress";

interface IExpandIconButtonProps extends IconButtonProps {
  expanded?: boolean;
}

const ExpandIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "expanded",
})<IExpandIconButtonProps>(({ theme, expanded }) => ({
  transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const CollapsableSection: React.FC<{
  title?: string;
  children?: React.ReactNode;
  isLoading?: boolean;
}> = ({ children, title = "", isLoading = false }) => {
  const [expanded, setExpanded] = useState(true);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  return (
    <>
      <div
        onClick={handleExpandClick}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <Typography
          style={{
            fontSize: pxToRem(14),
            fontWeight: 800,
            lineHeight: 1.36,
            color: "#663ea8",
          }}
        >
          {title}
        </Typography>
        <ExpandIconButton
          expanded={expanded}
          onClick={handleExpandClick}
          size="small"
        >
          <ExpandMoreIcon color="primary" />
        </ExpandIconButton>
      </div>
      <Divider
        style={{
          backgroundColor: "#8C62D1",
          height: 2,
        }}
      />
      <StyledCollapse
        style={{ flexGrow: isLoading && expanded ? 1 : undefined }}
        in={expanded}
        timeout="auto"
      >
        {isLoading && <Loading />}
        {!isLoading && <CollapseBody>{children}</CollapseBody>}
      </StyledCollapse>
    </>
  );
};

export default CollapsableSection;

const LoadingContainer = styled("div")({
  flexGrow: 1,
  display: "flex",
  justifyContent: "center",
  alignContent: "center",
  flexWrap: "wrap",
});
const Loading = () => (
  <LoadingContainer>
    <CircularProgress />
  </LoadingContainer>
);

const CollapseBody = styled("div")({
  display: "flex",
  alignItems: "start",
  flexWrap: "wrap",
  paddingTop: pxToRem(8),
});

const StyledCollapse = styled(Collapse)({
  display: "flex",
  alignSelf: "center",
  alignItems: "center",
  width: "100%",
  "& .MuiCollapse-wrapper": {
    display: "flex",
    flexGrow: 1,
  },
  "& .MuiCollapse-wrapperInner": {
    justifyContent: "center",
  },
});
